if ($(".id--16, .id--17").length) {
  $("#checkoutSidebar .order-summary-inner>h2.h4").text("Shrnutí objednávky");

  if ($("#checkoutSidebar .cart-items:not(.gift-items)").length) {
    $("#checkoutSidebar .cart-items:not(.gift-items) .main-link-variant").each(function () {
      const $el = $(this);
      const text = $el.text();

      const parts = text.split(", ");

      const result = parts
        .map((part, index) => {
          const idx = part.indexOf(":");
          const separator = index < parts.length - 1 ? ' <span class="superLabelSeparator">|</span>' : "";

          if (idx !== -1) {
            const label = part.substring(0, idx + 1);
            const rest = part.substring(idx + 1);

            return `<span class="superLabel"><b>${label}</b>${rest}${separator}</span>`;
          }

          return `<span class="superLabel">${part}${separator}</span>`;
        })
        .join("");

      $el.html(result);
    });
  }
  $(".content-inner .cart-row").before($(".cart-header"));
  $(".cart-items .cart-item").each(function () {
    $(this).find(".cart-item-name a").prepend($(this).find(".cart-item-amount").clone());
  });
  $("#checkoutContent .cart-content").append($('<div class="linBack"><a href="' + $(".next-step a.next-step-back").attr("href") + '">Předchozí krok</a></div>'));
  loadFooter(setFooter);

  function setFooter() {
    $("#checkoutSidebar .cart-content").append($("#footer .cartReviewsNGarantion").clone());
    $("#checkoutSidebar .cartReviewsNGarantion .reviews .item:not(.heureka) .count").text(googleRecenze);
    $("#checkoutSidebar .cartReviewsNGarantion .reviews .item:not(.heureka) .number .inner").text(pocetRecenzi);
    $("#checkoutSidebar .cartReviewsNGarantion .reviews .item.heureka .count").text(heurekaProcenta + "%");
    $("#checkoutSidebar .cartReviewsNGarantion .garantion p").text(garanceText);
  }

  $("#checkoutSidebar .cart-content").after($('<div class="linBack"><a href="' + $(".next-step a.next-step-back").attr("href") + '">Předchozí krok</a></div>'));
}
if ($(".id--16").length) {
  if ($('#order-shipping-methods>div').length == 1) {
    const $singleShipping = $('#order-shipping-methods>div').first();
    if ($singleShipping.attr("id") === jedinaDopravaID) {
      $('#order-shipping-methods').append($('#footer .onlyOneDelivery').clone());
    }
  }


  $('#order-billing-methods .radio-wrapper .payment-info').each(function () {
    var tooltipCart = $(this).find('.show-tooltip')
    if (tooltipCart.length) {
      tooltipCart.closest('span').hide();
      tooltipCart.closest('.payment-info').append('<span class="customPaymentInfo">' + tooltipCart.attr('title') + '</span>')
    }
  })
  function getDelivery() {
    const latestDate = sessionStorage.getItem("latestDeliveryDate");
    if (!latestDate) {
      return;
    }
    const formatted = new Date(latestDate).toLocaleString("cs-CZ", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
    });
    $("#order-shipping-methods label").each(function () {
      if (!$(this).find(".deliveryMax").length) {
        $(this).append('<div class="deliveryMax">Doručení do ' + formatted + "</div>");
      }
    });
  }
  getDelivery();

  $("#orderFormButton").on("click", function () {
    const $shipping = $('#order-shipping-methods input[type="radio"]:checked').closest(".radio-wrapper");
    const $payment = $('#order-billing-methods input[type="radio"]:checked').closest(".radio-wrapper");

    // Shipping
    const shippingName = $shipping.find(".shipping-billing-name").text().trim();
    const shippingPrice = $shipping.find(".payment-shipping-price").text().trim();
    const shippingImg = $shipping.find(".payment-logo img").attr("src") || "";

    let shippingPoint = "";
    const $deliveryPoint = $shipping.find('[data-testid="deliveryPoint"]');
    if ($deliveryPoint.length) {
      shippingPoint = $deliveryPoint.find(".chosen").first().text().trim();

      if (shippingPoint === "Změnit") {
        shippingPoint = "";
        $deliveryPoint.contents().each(function () {
          if (this.nodeType === 3) {
            shippingPoint += this.textContent;
          }
        });
        shippingPoint = shippingPoint.trim();
      }

      if (!shippingPoint) {
        shippingPoint = $deliveryPoint.text().trim();
      }
    }

    localStorage.setItem(
      "selectedShipping",
      JSON.stringify({
        name: shippingName,
        point: shippingPoint,
        price: shippingPrice,
        img: shippingImg,
      }),
    );

    // Payment
    const paymentName = $payment.find(".shipping-billing-name").text().trim();
    const paymentPrice = $payment.find(".payment-shipping-price").text().trim();
    const paymentImg = $payment.find(".payment-logo img").attr("src") || "";
    localStorage.setItem(
      "selectedPayment",
      JSON.stringify({
        name: paymentName,
        price: paymentPrice,
        img: paymentImg,
      }),
    );
  });

  if (doporucujemeKosik.doprava) {
    $("#order-shipping-methods>div").each(function () {
      if ($(this).attr("id") === doporucujemeKosik.doprava) {
        $(this).find(".payment-info").append('<span class="recommended">Doporučujeme</span>');
      }
    });
  }
  if (doporucujemeKosik.platba) {
    $("#order-billing-methods>div").each(function () {
      if ($(this).attr("data-id") === doporucujemeKosik.platba) {
        $(this).find(".payment-info").append('<span class="recommended">Doporučujeme</span>');
      }
    });
  }
}
if ($(".id--17").length) {
  if ($(".stay-in-touch").length) {
    $(".stay-in-touch").before(`<h4>Zůstaňme v kontaktu</h4>`);
  }
  $("#submit-order .order-button-text ").text("Odeslat objednávku s povinností platby");
  $("#submit-order").on("click", function () {
    const selectedShippingRaw = localStorage.getItem("selectedShipping");
    if (!selectedShippingRaw) {
      return;
    }

    let selectedShipping = null;
    try {
      selectedShipping = JSON.parse(selectedShippingRaw);
    } catch (error) {
      selectedShipping = null;
    }

    if (!selectedShipping) {
      return;
    }

    if (!selectedShipping.point || !selectedShipping.point.trim()) {
      const billStreet = ($("#billStreet").val() || "").trim();
      const billCity = ($("#billCity").val() || "").trim();
      const fallbackPoint = [billStreet, billCity].filter(Boolean).join(", ");

      if (fallbackPoint) {
        selectedShipping.point = fallbackPoint;
        const selectedShippingSerialized = JSON.stringify(selectedShipping);
        localStorage.setItem("selectedShipping", selectedShippingSerialized);
      }
    }
  });
  if (!getShoptetDataLayer("customer").registered) {
    $(".co-contact-information").prepend(`
            <div class="customLogin">
                    <p>Už máš účet? Přihlas se a ušetři čas s vyplňováním údajů.
                <span class="customLoginPopup">Přihlásit se</span></p>
        
            </div>
        `);
    $(".co-box.reg").prepend($("#set-registration").closest(".form-group"));
    $("html").on("click", ".customLoginPopup", function () {
      $("body").addClass("user-action-visible login-window-visible");
    });
  }

  $(document).ready(function () {
    $("#checkoutContent").css("opacity", "1");
  });
}

if ($(".ordering-process").length) {
  getSiteMessage();
}

if ($(".id--17").length) {
  if ($(".recapitulation-single").last().find('span[data-testid="recapItemPrice"]').text().trim() === translation("kc")) {
    $(".recapitulation-single").last().find('span[data-testid="recapItemPrice"]').text(translation("zdarma"));
  }
  $(function () {
    $('label[for="set-registration"]')
      .contents()
      .filter(function () {
        return this.nodeType === 3 && $.trim(this.nodeValue).length;
      })
      .first()
      .replaceWith(translation("textreg"));
  });
}
